import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './routes/Home';
import PublicWrapper from 'shared/components/layout/PublicWrapper';

const Landing = () => {
  return (
    <PublicWrapper>
      <Switch>
        <Route path='/' component={Home} />
      </Switch>
    </PublicWrapper>
  );
};

export default Landing;
